<script>
import Rules from "./Rules";
import Subscriptions from "./Subscriptions";

export default {
  title: "Assinaturas",
  components: {
    Rules,
    Subscriptions
  }
};
</script>

<template>
  <div>
    <Rules/>
    <Subscriptions/>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Subscription/Index.vue